import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(({ palette, spacing }) => ({
  card: {
    backgroundColor: palette.error.main,
    boxShadow: "none",
    display: "flex",
    flexDirection: "column",
    flexWrap: "nowrap",
    marginBottom: spacing(2),
    padding: spacing(3),
  },
  description: {
    marginTop: spacing(2),
  },
  icon: {
    color: palette.background.paper,
    marginRight: spacing(1),
  },
  textDescription: {
    color: palette.background.paper,
    fontSize: 14,
    fontWeight: 400,
  },
  textTitle: {
    color: palette.background.paper,
    fontSize: 16,
    fontWeight: 400,
  },
  title: {
    display: "flex",
    flexDirection: "row",
  },
}));
